import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import React, { useCallback } from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { isClassicEditorHost } from '../../utils/get-editor-host';
import { showErrorModal } from './show-error-modal';
export const getFailedAnalyzePagesModalProps = (t, editorHost) => ({
  content: isClassicEditorHost(editorHost) ? t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.content')),
  primaryButtonText: t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.secondary-button'),
  theme: 'destructive',
  title: t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.title')
});
export const useShowFailedAnalyzePagesModal = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const showFailedAnalyzePagesModal = useCallback(async function (_temp) {
    let {
      handleCancel
    } = _temp === void 0 ? {} : _temp;
    biLogger.modalView({
      modalType: BiModalTypes.UnableToAnalyzeSite
    });
    const modalProps = getFailedAnalyzePagesModalProps(t, editorHost);
    await showErrorModal({
      ...modalProps,
      a11yWizardAdapter,
      editorHost,
      primaryButtonOnClick: async () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Refresh,
          modalType: BiModalTypes.UnableToAnalyzePages
        });
        window.location.reload();
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType: BiModalTypes.UnableToAnalyzePages
        });
        handleCancel == null || handleCancel();
      }
    });
  }, [a11yWizardAdapter, biLogger, editorHost, t]);
  return showFailedAnalyzePagesModal;
};
//# sourceMappingURL=show-failed-analyze-pages-modal.js.map